import React from "react";
import PropTypes from "prop-types";

import { useTranslation } from "@common/hooks/translation";
import Spinner from "@common/components/spinner";

import "./style.scss";

const ActionSquare = ({ icon, actionName, onClick, className = "", isLoading }) => {
  const t = useTranslation();

  return (
    <div className={`P-action-square ${className}`} onClick={(e) => !isLoading && onClick?.(e)}>
      <i className={`global-icon ${icon}`} />
      <p>
        {t(...(Array.isArray(actionName) ? actionName : [actionName]))}
        {isLoading && <Spinner />}
      </p>
    </div>
  );
};

ActionSquare.propTypes = {
  icon: PropTypes.string,
  actionName: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ActionSquare;
